/**
 * Card recommendation types for the AI-powered escalation type recommender.
 * Maps agent responses to UI tile identifiers.
 */
/**
 * Single source of truth for all valid card identifiers.
 * Both the CardId type and the runtime validation Set derive from this array.
 */
const VALID_CARD_IDS = [
    "consumer",
    "volumeLicensingM365Azure",
    "postSalesSeller",
    "privacy",
    "technicalProduct",
    "absCopilot",
    "partnerProgram",
    "executive",
    "specialprogram",
    "customerConfidenceCall",
];
/** Runtime lookup Set derived from the same source array */
const VALID_CARD_ID_SET = new Set(VALID_CARD_IDS);
/** Type guard for CardId values */
export const isValidCardId = (value) => {
    return VALID_CARD_ID_SET.has(value);
};
